/* Static per-case page (cases/<ID>.html, built by scripts/generate-case-pages.js).
 *
 * Was emitted as an inline <script> inside the generated HTML until the CSP
 * dropped 'unsafe-inline' from script-src. The generator now links this file
 * instead — edit it here, not in the generator's template literal.
 */
(function() {
  var API_BASE = window.location.hostname === 'localhost' ? 'http://localhost:8000' : '';
  var caseId = document.getElementById('case-text').getAttribute('data-case-id');
  var originalText = document.getElementById('case-text').textContent;
  var currentLang = null;

  // Source-language display names. Keep in sync with js/datenbank.js and
  // LANG_NAMES_EN in api/services/translate.py.
  var LANG_NAMES = {
    de: { de: 'Deutschen',         en: 'German' },
    en: { de: 'Englischen',        en: 'English' },
    fr: { de: 'Franz\u00f6sischen',    en: 'French' },
    pl: { de: 'Polnischen',        en: 'Polish' },
    es: { de: 'Spanischen',        en: 'Spanish' },
    it: { de: 'Italienischen',     en: 'Italian' },
    nl: { de: 'Niederl\u00e4ndischen', en: 'Dutch' },
    pt: { de: 'Portugiesischen',   en: 'Portuguese' },
    cs: { de: 'Tschechischen',     en: 'Czech' },
    sv: { de: 'Schwedischen',      en: 'Swedish' },
    da: { de: 'D\u00e4nischen',        en: 'Danish' },
    fi: { de: 'Finnischen',        en: 'Finnish' },
    no: { de: 'Norwegischen',      en: 'Norwegian' }
  };

  // Type badges on the related-case cards link to their definition in
  // /methodology. They used to be <a href> nested inside the card's own <a>,
  // with onclick="event.stopPropagation()" to stop the card link firing too.
  // Nested anchors are invalid HTML — the parser auto-closes the outer <a>, so
  // the card's styling wrapped an empty stub and the rest of the card spilled
  // out of the box. They are now spans carrying data-def, matching the markup
  // js/datenbank.js already uses on /database, with the click handled here
  // instead of inline (script-src 'self' forbids on*= attributes).
  document.addEventListener('click', function (e) {
    var badge = e.target.closest('.case-type[data-def]');
    if (!badge || !badge.dataset.def) return;
    e.preventDefault();      // the card <a> would otherwise navigate as well
    e.stopPropagation();
    window.location.href = '/methodology#' + badge.dataset.def;
  });

  // Copy citation
  document.getElementById('copy-cite').addEventListener('click', function() {
    var text = document.getElementById('cite-text').textContent;
    navigator.clipboard.writeText(text).then(function() {
      var btn = document.getElementById('copy-cite');
      btn.textContent = 'Kopiert \u2713';
      btn.classList.add('copied');
      setTimeout(function() { btn.textContent = 'Kopieren'; btn.classList.remove('copied'); }, 2000);
    });
  });

  // Language toggle support
  document.addEventListener('langchange', function(e) {
    currentLang = e.detail.lang;
    fetch(API_BASE + '/v1/cases?limit=500&lang=' + encodeURIComponent(currentLang))
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var cases = data.cases || data;
        var c = cases.find(function(x) { return x.id === caseId; });
        if (!c) return;

        var blockquote = document.getElementById('case-text');
        blockquote.textContent = '\u201E' + (c.volltext || c.text) + '\u201C';

        // Provenance badge
        var existing = document.getElementById('provenance-badge');
        if (existing) existing.remove();

        // Source-language chip(s) in the meta-pill row.
        var chipsHost = document.getElementById('lang-chips');
        if (chipsHost) {
          chipsHost.innerHTML = '';
          if (c.translated) {
            var ulIso = (c.original_language || '').toUpperCase();
            var ulName = (LANG_NAMES[c.original_language] || {})[currentLang || 'de'] || ulIso;
            var chipTpl = window.i18n ? window.i18n.t('case.lang_chip') : '{iso} \u00B7 Original';
            var chipAriaTpl = window.i18n ? window.i18n.t('case.lang_chip_aria') : 'Original language: {lang}';
            var chip = document.createElement('span');
            chip.className = 'meta-pill meta-pill--lang ui-badge ui-badge--meta';
            chip.textContent = chipTpl.replace('{iso}', ulIso);
            chip.setAttribute('title', chipAriaTpl.replace('{lang}', ulName));
            chip.setAttribute('aria-label', chipAriaTpl.replace('{lang}', ulName));
            chipsHost.appendChild(chip);

            if (c.translation_fallback) {
              var uiLangCode = currentLang || 'de';
              var uiLangName = (LANG_NAMES[uiLangCode] || {})[uiLangCode] || uiLangCode.toUpperCase();
              var fbTpl = window.i18n ? window.i18n.t('case.translation_fallback_chip')
                : 'EN \u00B7 Translation (no {ui_lang} available)';
              var fbAriaTpl = window.i18n ? window.i18n.t('case.translation_fallback_aria')
                : 'No translation in {ui_lang} available; showing English translation';
              var fbChip = document.createElement('span');
              fbChip.className = 'meta-pill meta-pill--fallback ui-badge ui-badge--meta';
              fbChip.textContent = fbTpl.replace('{ui_lang}', uiLangName);
              fbChip.setAttribute('title', fbAriaTpl.replace('{ui_lang}', uiLangName));
              fbChip.setAttribute('aria-label', fbAriaTpl.replace('{ui_lang}', uiLangName));
              chipsHost.appendChild(fbChip);
            }
          }
        }

        if (c.translated) {
          var uiLang = currentLang || 'de';
          var srcName = (LANG_NAMES[c.original_language] || {})[uiLang] || c.original_language.toUpperCase();
          var isHuman = c.translation_source === 'human';
          var badge = document.createElement('div');
          badge.id = 'provenance-badge';
          badge.className = 'provenance-badge provenance-badge--detail';
          var labelKey = isHuman ? 'case.human_translated' : 'case.auto_translated';
          var labelFallback = isHuman
            ? (uiLang === 'de'
                ? 'Übersetzt aus dem {lang} · redaktionell geprüft'
                : 'Translated from {lang} · editorially reviewed')
            : (uiLang === 'de'
                ? 'Automatisch \u00FCbersetzt aus dem {lang}'
                : 'Automatically translated from {lang}');
          var labelTpl = window.i18n ? window.i18n.t(labelKey) : labelFallback;
          var label = labelTpl.replace('{lang}', srcName);
          var showOrigText = window.i18n
            ? window.i18n.t('case.show_original')
            : (uiLang === 'de' ? 'Original anzeigen' : 'Show original');
          badge.innerHTML = label + ' \u00B7 '
            + '<button class="provenance-toggle" id="toggle-original-page">'
            + showOrigText
            + '</button>';
          blockquote.parentNode.insertBefore(badge, blockquote.nextSibling);

          // "Original anzeigen" handler
          var showingOrig = false;
          document.getElementById('toggle-original-page').addEventListener('click', function() {
            showingOrig = !showingOrig;
            if (showingOrig) {
              blockquote.textContent = originalText;
              this.textContent = window.i18n
                ? window.i18n.t('case.show_translation')
                : (currentLang === 'en' ? 'Show translation' : '\u00DCbersetzung anzeigen');
            } else {
              blockquote.textContent = '\u201E' + (c.volltext || c.text) + '\u201C';
              this.textContent = window.i18n
                ? window.i18n.t('case.show_original')
                : (currentLang === 'en' ? 'Show original' : 'Original anzeigen');
            }
          });
        }

        // Update citation with (orig. XX) suffix
        var cite = document.getElementById('cite-text');
        var today = new Date().toISOString().split('T')[0];
        var langSuffix = c.original_language && c.original_language !== currentLang
          ? ' (orig. ' + c.original_language.toUpperCase() + ')' : '';
        cite.textContent = 'moiree.eu, Case ' + c.id + langSuffix + ', '
          + (currentLang === 'en' ? 'accessed ' : 'abgerufen ') + today;
      })
      .catch(function(err) { console.warn('[case-page] Translation fetch failed:', err); });
  });
})();
